import React, {useContext} from 'react'
import { DarkModeContext } from '../../global/Theme'
import './index.sass';



export default function Connection({prefix, img, text, handleInputChange, value=""}) {
    const { isDark } = useContext(DarkModeContext);


    return (
        <div className={isDark ? 'connection-large-dark' : 'connection-large'}>
            <img src={require(`../../assets/img/2${img}`)}/>
            <p>{prefix}</p>
            <input placeholder={text} type='text' value={value} onChange={handleInputChange} />
        </div>
    )
}
